export default class StaticMenu {
  constructor(options) {
    this.el = options.el;
  }

  render() {
    const path = window.location.pathname.replace(/^\/|\/$/g, '');
    const selector = `[href="/${path}"]`;

    this.el.querySelectorAll(selector).forEach((el) => {
      el.classList.add('current');
    });
  }
}
